/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `purchased_goods` - Purchased goods
* `sold_goods` - Sold goods
 */
export type ImportTypeEnum = typeof ImportTypeEnum[keyof typeof ImportTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImportTypeEnum = {
  purchased_goods: 'purchased_goods',
  sold_goods: 'sold_goods',
} as const;
